module.exports = __webpack_public_path__ + "static/media/EnterBG.9942c36b.mp4";